export default __webpack_public_path__ + "static/media/1720.085601cb.png";